import { TimeSlot } from './time-slot.model';
import { LessonType } from './lesson-type.model';
import { Instructor } from './instructor.model';
import { ReservationSubItem } from './reservation.model';

export class Lesson {
  id: number;
  lessonType: LessonType;
  students: ReservationSubItem[];
  timeSlots: TimeSlot[];
  instructor: Instructor;
  name: string;
}
